import type { FetchTasksResponseData } from 'gcs-common/clients/api/entities/tasks/tasks-api-helpers';
import { useGetDoneTasks } from 'gcs-common/clients/api/entities/tasks/tasks-api-selectors';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import { type Dispatch, type SetStateAction, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Task from '../Task/Task';
import styles from './styles.module.scss';

interface DoneListProps {
  setTaskDueSelect: Dispatch<SetStateAction<FetchTasksResponseData['tasks'][number] | null>>;
  showAll: boolean;
}

const DoneList = ({ setTaskDueSelect, showAll }: DoneListProps) => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const doneTasks = useGetDoneTasks(selectedChannelId);

  const [alwaysShown, possiblyHidden] = useMemo(() => {
    return [doneTasks?.slice(0, 3), doneTasks?.slice(3)];
  }, [doneTasks]);

  return (
    <div className={styles.doneList}>
      <div className={styles.sectionTitle}>Erledigt!</div>
      <div>
        {/* biome-ignore lint/complexity/useOptionalChain: <explanation> */}
        {alwaysShown &&
          alwaysShown.map((task) => {
            return <Task dark task={task} key={task.id} setTaskDueSelect={setTaskDueSelect} />;
          })}
      </div>
      <div
        className={styles.possiblyHidden}
        style={{
          height: showAll ? 'auto' : '10px',
          overflow: showAll ? 'auto' : 'visible',
        }}
      >
        {/* biome-ignore lint/complexity/useOptionalChain: <explanation> */}
        {possiblyHidden &&
          possiblyHidden.map((task) => {
            return <Task dark task={task} key={task.id} setTaskDueSelect={setTaskDueSelect} />;
          })}
      </div>
    </div>
  );
};

export default DoneList;
